// extracted by mini-css-extract-plugin
module.exports = {"content":"CloseAccount_content__1JKkH","row":"CloseAccount_row__gA_7G","modal":"CloseAccount_modal__WywWS","img":"CloseAccount_img__269Mq","title":"CloseAccount_title__lAc8j"};